// src/components/EventForm/EventFormContentTags.jsx
import React from 'react';

const extraTags = [
  { label: 'Live Music', value: 'live_music' },
  { label: 'Outdoor Event', value: 'outdoor_event' },
  { label: 'Food Available', value: 'food_available' },
  { label: 'Free Entry', value: 'free_entry' },
];

const EventFormContentTags = ({ formData, onChange, errorFields = [] }) => {
  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    const updated = checked
      ? [...formData.additionalTags, value]
      : formData.additionalTags.filter((tag) => tag !== value);
    onChange('additionalTags', updated);
  };

  return (
    <div className="event-form-tags mb-6 p-4 bg-bg-light rounded shadow-inner">
      {/* Required dropdown for audience */}
      <div className="mb-4">
        <label className="label">Event Audience * {errorFields?.includes('contentRating') && <span className="text-error">*</span>}</label>
        <select
          value={formData.contentRating}
          onChange={(e) => onChange('contentRating', e.target.value)}
          required
          className="input-field"
        >
          <option value="">-- Select Audience --</option>
          <option value="family_friendly">Family Friendly</option>
          <option value="18_plus">18+ Only</option>
          <option value="21_plus">21+ Only</option>
        </select>
      </div>

      {/* Required Yes/No for bar & dispensary */}
      <div className="mb-4">
        <label className="label">Is this event associated with a bar? * {errorFields?.includes('bar') && <span className="text-error">*</span>}</label>
        <div className="flex gap-4">
          <label><input type="radio" name="bar" value="yes" checked={formData.bar === 'yes'} onChange={() => onChange('bar', 'yes')} required /> Yes</label>
          <label><input type="radio" name="bar" value="no" checked={formData.bar === 'no'} onChange={() => onChange('bar', 'no')} required /> No</label>
        </div>
      </div>

      <div className="mb-4">
        <label className="label">Is this event associated with a marijuana dispensary? * {errorFields?.includes('dispensary') && <span className="text-error">*</span>}</label>
        <div className="flex gap-4">
          <label><input type="radio" name="dispensary" value="yes" checked={formData.dispensary === 'yes'} onChange={() => onChange('dispensary', 'yes')} required /> Yes</label>
          <label><input type="radio" name="dispensary" value="no" checked={formData.dispensary === 'no'} onChange={() => onChange('dispensary', 'no')} required /> No</label>
        </div>
      </div>

      <div className="mb-4">
        <label className="label">Are dogs welcome at the event? * {errorFields?.includes('dogs') && <span className="text-error">*</span>}</label>
        <div className="flex gap-4">
          <label>
            <input
              type="radio"
              name="dogs"
              value="yes"
              checked={formData.dogs === 'yes'}
              onChange={() => onChange('dogs', 'yes')}
              required
            />{' '}
            Yes
          </label>
          <label>
            <input
              type="radio"
              name="dogs"
              value="no"
              checked={formData.dogs === 'no'}
              onChange={() => onChange('dogs', 'no')}
              required
            />{' '}
            No
          </label>
        </div>
      {/* Commercial Promotion Flag */}
      <div className="mb-4">
        <label className="label">Is this a commercial/business promotion? * {errorFields?.includes('commercial') && <span className="text-error">*</span>}</label>
        <div className="flex gap-4">
          <label>
            <input
              type="radio"
              name="commercial"
              value="yes"
              checked={formData.commercial === 'yes'}
              onChange={() => onChange('commercial', 'yes')}
              required
            />{' '}
            Yes
          </label>
          <label>
            <input
              type="radio"
              name="commercial"
              value="no"
              checked={formData.commercial === 'no'}
              onChange={() => onChange('commercial', 'no')}
              required
            />{' '}
            No
          </label>
        </div>
      </div>
      </div>


      {/* Optional extra tags */}
      <div>
        <h3 className="text-lg font-semibold mb-2">Other Tags</h3>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {extraTags.map((tag) => (
            <label key={tag.value} className="inline-flex items-center space-x-2">
              <input
                type="checkbox"
                value={tag.value}
                checked={formData.additionalTags.includes(tag.value)}
                onChange={handleCheckboxChange}
                className="accent-blue-600"
              />
              <span>{tag.label}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventFormContentTags;
